import axios from "axios";

export const getJobDetailDisplay = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobdetaildisplay/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editJobDetailDisplay = (careersClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobdetaildisplay/editjobdetailconfiguration/" +
        encodeURIComponent(careersClientId),
      data
    )
    .then((res) => res.data);
};
